import http from '../../../services/api'
import type { APIPaginatedResponse, Filters, Pagination } from '../../../services/types'
import { getExpenseListParamString } from './expenseListQueryParams'
import type {
  ExpenseCategoryApi,
  ExpenseCategoryCreatePayload,
  ExpenseCategoryUpdatePayload,
  ExpenseItemApi,
} from '../types'

const apiPath = import.meta.env.VITE_API_PATH
const basePath = `${apiPath}expenses/categories`

type ExpenseCategorySingleResponse = { data: ExpenseCategoryApi }

async function getExpenseCategories(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getExpenseListParamString(filters, pagination)
  return await http.get<APIPaginatedResponse<ExpenseCategoryApi>>(basePath + paramString)
}

/** GET /expenses/categories/active — active categories only (paginated / filterable). */
async function getActiveExpenseCategories(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getExpenseListParamString(filters, pagination)
  return await http.get<APIPaginatedResponse<ExpenseCategoryApi>>(`${basePath}/active${paramString}`)
}

/** GET /expenses/categories/{categoryUuid}/items — items belonging to that category (paginated / filterable). */
async function getExpenseCategoryItems(
  categoryUuid: string,
  filters?: Partial<Filters>,
  pagination?: Partial<Pagination>,
) {
  const paramString = getExpenseListParamString(filters, pagination)
  return await http.get<APIPaginatedResponse<ExpenseItemApi>>(`${basePath}/${categoryUuid}/items${paramString}`)
}

async function createExpenseCategory(payload: ExpenseCategoryCreatePayload) {
  return await http.post<ExpenseCategorySingleResponse>(basePath, payload)
}

async function updateExpenseCategory(uuid: string, payload: ExpenseCategoryUpdatePayload) {
  return await http.put<ExpenseCategorySingleResponse>(`${basePath}/${uuid}`, payload)
}

async function deleteExpenseCategory(uuid: string) {
  return await http.delete<undefined>(`${basePath}/${uuid}`)
}

const expenseCategoriesService = {
  getExpenseCategories,
  getActiveExpenseCategories,
  getExpenseCategoryItems,
  createExpenseCategory,
  updateExpenseCategory,
  deleteExpenseCategory,
}

export default expenseCategoriesService
